import React from 'react';

export const CompanyNameContext = React.createContext({
  companyName: null,
  companyLogo: null,
  setCompanyNameAndLogo: () => {},
  isEmpty: () => {}
});
